import { isServer } from '../runtimeEnv'

export const getApiUrl = (): string => {
  if (isServer) {
    return process.env.API_URL_SERVER || /* istanbul ignore next */ ''
  }

  return process.env.API_URL || /* istanbul ignore next */ ''
}
